module.exports = __webpack_public_path__ + "static/media/Abs-&-Cardio.64420c04.jpeg";